import { Course } from './../builders/course_builder';
import { ITransferPendingCoursesDatasource } from './../datasources/transfer_pending_courses_datasource';
import { IDefineCommand, IQueryMediator, ICommand, IQuery } from 'core-ts-types';

angular
  .module('capability-ng-transfer')
  .factory(
    'removeTransferPendingCourseCommand',
    (
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngTransferPendingCoursesDatasource: ITransferPendingCoursesDatasource,
      $http: ng.IHttpService,
      transferMajorTileDelegate: any
    ): ICommand => {
      return defineCommand(
        'removeTransferPendingCourseCommand',
        (deferred: ng.IDeferred<IQuery[]>, collegeNk: string, course: Course) => {
          $http({
            method: 'DELETE',
            url: `student/college/${collegeNk}/pending-course/${course.id}`
          })
            .then((response: ng.IHttpPromiseCallbackArg<any>) => {
              ngTransferPendingCoursesDatasource.del(course);

              deferred.resolve(QueryMediator.runQueries(ngTransferPendingCoursesDatasource));
            })
            .catch(deferred.reject);
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/remove_transfer_pending_course_command.ts